module.exports = __webpack_public_path__ + "static/media/Jaipur architecture fest 2019 award 1.1.eeb59430.png";